import { render, staticRenderFns } from "./BaseThaiAddressAutocomplete.vue?vue&type=template&id=57a3da16&"
import script from "./BaseThaiAddressAutocomplete.vue?vue&type=script&lang=js&"
export * from "./BaseThaiAddressAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib/components/VCombobox';
installComponents(component, {VCombobox})
